/**
 * @description 下载文件
 * @author wangfupeng
 */

import { URL_PARAMS } from './params'

export default function (eventData = {}) {
    // aio 全局变量
    const downloadUrl = eventData.downloadUrl
    if (!downloadUrl) {
        console.error('download url is null or undefined')
        return
    }

    // 手机号、邮箱、onetravel、diditravel协议直接跳转
    if (/^(onetravel|diditravel|tel|mailto).*/i.test(downloadUrl)) {
        location.href = downloadUrl
        return
    }

    const newDownloadUrl = K.query.build(downloadUrl, URL_PARAMS())
    window.location.href = newDownloadUrl
}
